export default __webpack_public_path__ + "static/media/male.b552d7c1.jpg";